import { ANYTHING, CacheScenario, CacheTime, MethodType } from '../models/api/cache';
import { API_ENDPOINT } from './utils.service';

export const exportServiceCache: () => CacheScenario[] = (): CacheScenario[] => [
  {
    description: 'getMttrGraphInformation',
    cacheTime: CacheTime.VERY_LONG,
    endpoint: {
      url: `${API_ENDPOINT}/export/mttr/${ANYTHING}/graph`,
      method: MethodType.GET,
    },
    cleaningEndpoints: [],
  },
  {
    description: 'getMttbfGraphInformation',
    cacheTime: CacheTime.VERY_LONG,
    endpoint: {
      url: `${API_ENDPOINT}/export/mtbf/${ANYTHING}/graph`,
      method: MethodType.GET,
    },
    cleaningEndpoints: [],
  },
  {
    description: 'getMttfGraphInformation',
    cacheTime: CacheTime.VERY_LONG,
    endpoint: {
      url: `${API_ENDPOINT}/export/mttf/${ANYTHING}/graph`,
      method: MethodType.GET,
    },
    cleaningEndpoints: [],
  },
  {
    description: 'getMttfMttbfGraphInformation',
    cacheTime: CacheTime.VERY_LONG,
    endpoint: {
      url: `${API_ENDPOINT}/export/mtx/${ANYTHING}/graph`,
      method: MethodType.GET,
    },
    cleaningEndpoints: [],
  },
];
